import { Row } from 'antd';
import CheckboxMenu from '../../ui/CheckboxMenu/CheckboxMenu';
import './Filter.css';
import AcademicRank from './components/AcademicRank';
import Creator from './components/Creator';
import Institution from './components/Institution';
import Modality from './components/Modality';
import ProcedureGroup from './components/ProcedureGroup';
import ProcedureName from './components/ProcedureName';
import Role from './components/Role';
import ShareBy from './components/ShareBy';
import Status from './components/Status';
import ClearFilter from './templates/ClearFilter';
import DateRange from './templates/DateRange';
import InputFilter from './templates/InputFilter';
import SearchFilter from './templates/SearchFilter';
import SelectFilter from './templates/SelectFilter';

interface SubComponents {
  Search: typeof SearchFilter;
  Clear: typeof ClearFilter;
  Checkbox: typeof CheckboxMenu;
  DateRange: typeof DateRange;
  Input: typeof InputFilter;
  SelectFilter: typeof SelectFilter;

  Status: typeof Status;
  Role: typeof Role;
  AcademicRank: typeof AcademicRank;
  Creator: typeof Creator;
  Institution: typeof Institution;
  ProcedureName: typeof ProcedureName;
  ProcedureGroup: typeof ProcedureGroup;
  Modality: typeof Modality;
  ShareBy: typeof ShareBy;
}

const Filter: React.FC<any> & SubComponents = ({ children }: { children: JSX.Element[] }) => {
  return (
    <Row className="filter-wrapper ml-[-7px] space-y-2 pt-3 pb-6 text-base" align="bottom">
      {children}
    </Row>
  );
};

Filter.Search = SearchFilter;
Filter.Clear = ClearFilter;
Filter.Checkbox = CheckboxMenu;
Filter.DateRange = DateRange;
Filter.Input = InputFilter;
Filter.SelectFilter = SelectFilter;

Filter.Status = Status;
Filter.Role = Role;
Filter.AcademicRank = AcademicRank;
Filter.Creator = Creator;
Filter.Institution = Institution;
Filter.ProcedureName = ProcedureName;
// Filter.ProcedureGroup = ProcedureGroup;
Filter.Modality = Modality;
Filter.ShareBy = ShareBy;

export default Filter;
